import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, unref as _unref, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "space-y-8 divide-y divide-gray-200" };
const _hoisted_2 = { class: "space-y-8 divide-y divide-gray-200 sm:space-y-5" };
const _hoisted_3 = { class: "space-y-6 pt-8 sm:space-y-5 sm:pt-10" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-900" }, "Team Details")
], -1);
const _hoisted_5 = { class: "space-y-6 sm:space-y-5" };
const _hoisted_6 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2" }, "Active", -1);
const _hoisted_8 = { class: "mt-4" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("legend", { class: "sr-only" }, "Team Active Status", -1);
const _hoisted_10 = { class: "mr-2 flex flex-row align-center" };
const _hoisted_11 = ["id", "value", "name", "checked"];
const _hoisted_12 = ["for"];
const _hoisted_13 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", {
    for: "kronos-team-id",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "ID", -1);
const _hoisted_15 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_16 = ["disabled"];
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { class: "text-red-600" };
const _hoisted_19 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("label", {
    for: "kronos-team-label",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "Display name", -1);
const _hoisted_21 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_22 = ["disabled"];
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, "Shown to users in the Amend form (e.g. type name).", -1);
const _hoisted_24 = { class: "pt-5" };
const _hoisted_25 = { class: "flex justify-end" };
const _hoisted_26 = ["disabled"];
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { onMounted, reactive } from 'vue';
import { useStore } from 'vuex';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'KronosTeamForm',
    props: {
        contractId: {},
        selectedTeam: {}
    },
    emits: ["cancel"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const formData = reactive({
            LKStatus: true,
            ID: '',
            Label: '',
        });
        const rules = {
            formData: {
                LKStatus: { required },
                ID: { required },
            },
        };
        const v$ = useVuelidate(rules, { formData });
        const handleSave = async () => {
            store.dispatch('setIsLoading', true);
            try {
                const payload = {
                    type: 'kronosTeam',
                    contractId: props.contractId,
                    ...formData,
                };
                const response = await httpClient.post('/config/create', payload);
                if (response.data.statusCode === 500)
                    throw new Error();
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'Success!',
                    message: props.selectedTeam ? 'Changes saved' : 'Successfully created new team',
                });
                emit('cancel', { refresh: true });
            }
            catch (err) {
                console.log(err);
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: props.selectedTeam ? 'Error saving changes' : 'Could not create team',
                });
            }
            store.dispatch('setIsLoading', false);
        };
        onMounted(() => {
            if (props.selectedTeam) {
                Object.assign(formData, props.selectedTeam);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createTextVNode(),
                                _createElementVNode("fieldset", _hoisted_8, [
                                    _hoisted_9,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_10, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([true, false], (item) => {
                                            return _createElementVNode("div", {
                                                key: item,
                                                class: "flex items-center mr-6"
                                            }, [
                                                _withDirectives(_createElementVNode("input", {
                                                    id: `LKStatus-${item.toString()}`,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.LKStatus) = $event)),
                                                    value: item,
                                                    name: `LKStatus-${item.toString()}`,
                                                    type: "radio",
                                                    checked: formData.LKStatus === item,
                                                    class: "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                                }, null, 8, _hoisted_11), [
                                                    [_vModelRadio, formData.LKStatus]
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("label", {
                                                    for: `LKStatus-${item.toString()}`,
                                                    class: "ml-3 block text-sm font-medium text-gray-700"
                                                }, _toDisplayString(item.toString()), 9, _hoisted_12)
                                            ]);
                                        }), 64))
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_13, [
                                _hoisted_14,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_15, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "kronos-team-id",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formData.ID) = $event)),
                                        type: "text",
                                        name: "kronos-team-id",
                                        class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:text-gray-800 disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        disabled: !!_ctx.selectedTeam,
                                        onBlur: _cache[2] || (_cache[2] = ($event) => (_unref(v$).formData.ID.$touch()))
                                    }, null, 40, _hoisted_16), [
                                        [_vModelText, formData.ID]
                                    ]),
                                    _createTextVNode(),
                                    (_unref(v$).formData.ID?.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _createElementVNode("p", _hoisted_18, "* " + _toDisplayString(_unref(v$).formData.ID.$errors[0].$message), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_19, [
                                _hoisted_20,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_21, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "kronos-team-label",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((formData.Label) = $event)),
                                        type: "text",
                                        name: "kronos-team-label",
                                        class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:text-gray-800 disabled:bg-gray-200 disabled:cursor-not-allowed",
                                        disabled: !!_ctx.selectedTeam
                                    }, null, 8, _hoisted_22), [
                                        [_vModelText, formData.Label]
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_23
                                ])
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 hover:underline",
                            onClick: _cache[4] || (_cache[4] = ($event) => (emit('cancel')))
                        }, "\n          Cancel\n        "),
                        _createTextVNode(),
                        _createElementVNode("button", {
                            disabled: _unref(v$).$invalid,
                            type: "submit",
                            class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                            onClick: _withModifiers(handleSave, ["prevent"])
                        }, "\n          Save\n        ", 8, _hoisted_26)
                    ])
                ])
            ]));
        };
    }
});
